import { Box, Button, Link, Paper, Stack, styled, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useNavigate } from 'react-router-dom';

const PaperStyled = styled(Paper)`
  width: 100%;
  padding: 24px;
`;

const AttentionText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  backgroundColor: theme.palette.error.light,
  padding: 16,
  borderRadius: 4,
  textAlign: 'center'
}));

const center = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const AttentionPage = () => {
  const navigate = useNavigate();

  const handleAcknowledgement = () => {
    navigate('/registration');
  };

  return (
    <PaperStyled>
      <Stack sx={{ ...center }}>
        <Box sx={{ ...center }} gap={2}>
          <ErrorIcon sx={{ fontSize: 50, color: 'error.main' }} />
          <Typography variant="h5" sx={{ color: 'error.main' }}>
            Perhatian
          </Typography>
        </Box>
        <Box sx={{ maxWidth: 500, my: 3 }}>
          <AttentionText variant="body1">
            Untuk membuka akun perusahaan, Pastikan jika anda adalah pejabat yang berwenang sesuai Anggaran Dasar
            Perusahaan terkini atau pegawai yang diberikan surat kuasa oleh pejabat berwenang pada perusahaan.
          </AttentionText>
        </Box>
        <Box sx={{ maxWidth: 650, mb: 3 }}>
          <Typography variant="body1" sx={{ fontWeight: 600, textAlign: 'center' }}>
            Untuk memperlancar proses pembukaan akun perusahaan, Pastikan anda telah mempersiapkan informasi serta
            dokumen yang diperlukan sesuai dengan petunjuk proses pembukaan akun perusahaan{' '}
            <Link
              href="https://docs.google.com/document/d/1mFiLdeFA0yBw1XbdLGybI7L8PemD_FhVnmeLR6-Nf_0/edit#heading=h.s6tqfgcj75rk"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: 'inline' }}
            >
              disini
            </Link>
          </Typography>
        </Box>
        <Button variant="contained" sx={{ maxWidth: 200 }} onClick={handleAcknowledgement}>
          Saya mengerti
        </Button>
      </Stack>
    </PaperStyled>
  );
};

export default AttentionPage;
